import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { WhyUs } from './components/WhyUs';
import { BeforeAfter } from './components/BeforeAfter';
import { Gallery } from './components/Gallery';
import { Reviews } from './components/Reviews';
import { CTABanner } from './components/CTABanner';
import { ServiceAreas } from './components/ServiceAreas';
import { Footer } from './components/Footer';
import { FloatingMessageButton } from './components/FloatingMessageButton';
export function App() {
  return <div className="min-h-screen bg-tan font-sans text-gray-900 selection:bg-gold selection:text-forest-dark" data-id="element-0">
      <Header data-id="element-1" />
      <FloatingMessageButton data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <Services data-id="element-5" />
        <BeforeAfter data-id="element-6" />
        <WhyUs data-id="element-7" />
        <Gallery data-id="element-8" />
        <Reviews data-id="element-9" />
        <CTABanner data-id="element-10" />
        <ServiceAreas data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}